import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  account: {},
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
}



// WEBPACK FOOTER //
// ./src/devicehq/store/modules/account/index.js